import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './AdminNavigation.css';

const AdminNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    navigate('/admin/login');
  };

  const navItems = [
    {
      path: '/admin/dashboard',
      icon: '📊',
      label: 'Dashboard',
      description: 'Overview & stats'
    },
    {
      path: '/admin/products',
      icon: '📦',
      label: 'Products',
      description: 'Manage products'
    },
    {
      path: '/admin/orders',
      icon: '🛒',
      label: 'Orders',
      description: 'View & process orders'
    },
    {
      path: '/admin/users',
      icon: '👥',
      label: 'Users',
      description: 'Manage users'
    }
  ];

  return (
    <nav className="admin-navigation">
      <div className="admin-nav-container">
        <div className="admin-nav-brand">
          <h2>⚡ GoldVines Admin</h2>
        </div>

        <div className="admin-nav-links">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`admin-nav-link ${location.pathname === item.path ? 'active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              <div className="nav-text">
                <span className="nav-label">{item.label}</span>
                <span className="nav-description">{item.description}</span>
              </div>
            </Link>
          ))}
        </div>

        <button className="admin-nav-logout" onClick={handleLogout}>
          <span>🚪</span>
          Logout
        </button>
      </div>
    </nav>
  );
};

export default AdminNavigation;